module.exports = __webpack_public_path__ + "static/media/more.c97279db.svg";